import { Link, useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import i18n from 'i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();
  const lang = useMemo(() => {
    const pathLang = location.pathname.split('/')[1];
    if (['en', 'fr', 'de', 'da'].includes(pathLang)) return pathLang;
    return 'en';
  }, [location.pathname]);

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar lang={lang} />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-background-100 flex items-center justify-center">
            <i className="ri-error-warning-line text-4xl text-foreground-400" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4 font-heading">
            404
          </h1>
          <p className="text-base md:text-lg text-foreground-600 mb-8">
            Page not found. The resource you are looking for may have moved or does not exist.
          </p>
          <Link
            to={`/${lang}`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-line" />
            Go to Homepage
          </Link>
        </div>
      </main>
      <Footer lang={lang} />
    </div>
  );
}